/* jshint esversion: 8 */
/* jshint node: true */

import React from "react";

const dashboardPageContainer = (props) => {
  return <div className="dashboard-page__main">{props.contents}</div>;
};

export default dashboardPageContainer;
